import { render } from "./DonationInfo.vue?vue&type=template&id=717ace19&ts=true"
import script from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-three/DonationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "717ace19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('717ace19', __exports__)) {
    api.reload('717ace19', __exports__)
  }
  
  module.hot.accept("./DonationInfo.vue?vue&type=template&id=717ace19&ts=true", () => {
    api.rerender('717ace19', render)
  })

}


export default __exports__